// CUSTODY FLOW (UI rebuild batch 4 · custody setup · reference build) — Astra's "how deposits become spendable funds": a
// process guide reached on demand, never the landing. The operator's own seven steps (17 Oct 2026, docs/WALLET-FLOW-
// BUILD-2026-10-17.md), each one line and one Open to the screen where the work happens. No live status: a guide is not
// proof that any stage passed (Astra's check) — the stages' own screens say that from their reads. Caps, fee floors and
// device administration moved to Custody settings and Devices & keys (two buttons under the guide).
import { Link } from 'react-router-dom';
import { PageHead, Panel } from '../../../components/v2/kit';
import { CA, OPS } from '../../../components/v2/custody-admin/paths';

const STEPS: ReadonlyArray<{ title: string; line: string; to: string }> = [
  { title: 'Register the Ledger', line: 'Register each account key once, by cable.', to: CA.keys },
  { title: 'Issue address', line: 'A checked address for the customer.', to: CA.addresses },
  { title: 'Customer pays', line: 'The deposit lands and is screened.', to: OPS.deposits },
  { title: 'Sweep', line: 'Rated money routes by its rating; sign it.', to: OPS.approvals },
  { title: 'Payout address', line: 'Owner approves, 10 USDT test, Received.', to: CA.payouts },
  { title: 'Pay', line: 'Pay a whitelisted address; sign by phone.', to: CA.payouts },
  { title: 'Treasury', line: 'Keep reserves in Treasury; refill Hot.', to: OPS.balances },
];

export function CustodyFlowV2() {
  return (
    <>
      <PageHead title="Custody flow" />
      <Panel title="How funds move" flush>
        <ol>
          {STEPS.map((s, i) => (
            <li key={s.title} className="grid grid-cols-[32px_minmax(0,1fr)_auto] items-center gap-3 border-b border-stroke-soft px-4 py-4 last:border-b-0 lg:px-5">
              <span className="grid h-8 w-8 place-items-center rounded-full border border-stroke font-mono text-meta text-tg-hint" aria-hidden>{i + 1}</span>
              <span className="min-w-0">
                <span className="block text-body font-medium">{s.title}</span>
                <span className="mt-1 block text-meta text-tg-hint">{s.line}</span>
              </span>
              <Link to={s.to} className="btn-secondary px-4 text-body" aria-label={`Open ${s.title}`}>Open</Link>
            </li>
          ))}
        </ol>
      </Panel>
      <div className="mt-4 flex flex-wrap gap-2">
        <Link to={CA.keys} className="btn-secondary px-4 text-body">Devices &amp; keys</Link>
        <Link to={CA.settings} className="btn-secondary px-4 text-body">Custody settings</Link>
      </div>
    </>
  );
}
